import { apiClient } from '@lib/api-client';
import { TMutationConfig } from '@lib/react-query';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/* API                                                                        */
/* -------------------------------------------------------------------------- */

export const verifyOrganization = ({
	id,
	legalIdentifier,
}: {
	id: string | number;
	legalIdentifier: string;
}): Promise<any> => {
	return apiClient.patch(`/organizations/verify/${id}`, {
		legalIdentifier,
	});
};

/* -------------------------------------------------------------------------- */
/* Hook                                                                       */
/* -------------------------------------------------------------------------- */

type TUseVerifyOrganizationOptions = {
	mutationConfig?: TMutationConfig<
		typeof verifyOrganization
	>;
};

export const useVerifyOrganization = ({
	mutationConfig,
}: TUseVerifyOrganizationOptions = {}) => {
	const { onSuccess, ...restConfig } =
		mutationConfig || {};
	const { t } = useTranslation();

	return useMutation({
		mutationFn: verifyOrganization,
		onSuccess: (...args) => {
			onSuccess?.(...args);
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
		...restConfig,
	});
};
